import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import PostRail from '../shared/PostRail';
import { SectionCard } from '../shared/insightUi';

export default function RecentReels({ recent_reels = [] }) {
  const posts = (Array.isArray(recent_reels) ? recent_reels : []).slice(0, 30);
  if (!posts.length) return null;
  return (
    <SectionCard
      icon={<PlayCircleRoundedIcon fontSize="small" />}
      title="Recent reels"
      subtitle="Latest reels published on this profile"
      bodyPadding="16px 24px 12px"
    >
      <PostRail posts={posts} />
    </SectionCard>
  );
}
